module.exports = __webpack_public_path__ + "img/img3.0ef7437c.png";